/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ObjectTypeModel from 'cio/models/object-type';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import AlertsService from 'cio/services/alerts';
import { task } from 'ember-concurrency';
import { announceRefreshWorkspaces } from '@customerio/hydra-nav-state';
import HydraService from 'cio/services/hydra';

interface DeleteObjectTypeFormArgs {
  objectTypes: ObjectTypeModel[];
  onClose: () => unknown;
}

export default class DeleteObjectTypeModal extends Component<DeleteObjectTypeFormArgs> {
  @service alerts!: AlertsService;
  @service hydra!: HydraService;

  @tracked inputVal = '';

  get isDeleteDisabled() {
    return Number(this.inputVal) !== this.args.objectTypes.length;
  }

  deleteObjectTypesTask = task(async () => {
    let { objectNames, objectPromises } = this.args.objectTypes.reduce(
      (acc, objectType) => {
        acc.objectNames.push(objectType.name);
        acc.objectPromises.push(objectType.destroyRecord());
        return acc;
      },
      {
        objectNames: [] as string[],
        objectPromises: [] as Promise<ObjectTypeModel>[],
      },
    );

    let results = await Promise.allSettled(objectPromises);

    let deletedObjectNames: string[] = [];
    let notDeletedObjectNames: string[] = [];

    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        deletedObjectNames.push(result.value.name);
      } else {
        // rejected promises don't have value, only reason for why it was rejected, which is why there is objectNames array
        notDeletedObjectNames.push(
          `Something went wrong when we tried to delete ${objectNames[index]}. Reason: ${result.reason}. Please try again.`,
        );
      }
    });

    if (deletedObjectNames.length > 0) {
      this.alerts.success('object-type.success', `${deletedObjectNames.join(', ')} deleted`);

      if (this.hydra.isHydraEnabled) {
        // let's force hydra to refresh the side navigation bar to add the new object
        announceRefreshWorkspaces();
      }
    }

    notDeletedObjectNames.forEach((errorMessage, index) => {
      this.alerts.error(`object-type.error-${index}`, errorMessage);
    });

    this.args.onClose();
  });
}
